module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_check_white-8ec78c29d5349cc08b35b1f7ce51090d.svg";